import React, { useEffect, useRef, useState } from 'react';
import Button from 'react-bootstrap/Button';
import FadeIn from 'react-fade-in/lib/FadeIn';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import ReactMarkdown from 'react-markdown';
import { layoutDefaults } from '../utils/layout-defaults';

function PrivacyNotice({ analytics, getPrivacyPolicyFromRemote }) {
  const { analyticsFeatureUseEvent } = analytics;
  // const { getLoginPrivacyPolicyFromRemote } = publicAPI;
  const [isOpen, setIsOpen] = useState(false);
  const [privacy, setPrivacy] = useState();
  const privacyContainerRef = useRef();
  const { t } = useTranslation();
  const classes = useStyles();

  useEffect(() => {
    async function loadPolicy() {
      try {
        const response = await getPrivacyPolicyFromRemote();
        setPrivacy(response.data);
      } catch (error) {
        setPrivacy(
          `${t(
            'privacy-notice.access-at'
          )} [http://www.menur.app](http://www.menur.app).`
        );
      }
    }

    loadPolicy();
  }, []);

  const didToogle = () => {
    analyticsFeatureUseEvent(`privacy terms ${!isOpen ? 'open' : 'close'}`);
    setIsOpen(!isOpen);
  };

  return (
    <div className={classes.container}>
      {/* "card-payment.modal.title": "Carte" */}
      <div className={classes.subTitle}>
        {`${t('privacy-notice.we-respect')}`}
        <Button variant="link" onClick={didToogle} className={classes.link}>
          {t('privacy-notice')}
        </Button>
      </div>
      {/* </FadeIn> */}

      {isOpen && (
        <FadeIn>
          <div ref={privacyContainerRef} className={classes.privacyContainer}>
            <div className={classes.privacy}>
              <ReactMarkdown
                allowElement={(element, index, parent) =>
                  !(
                    element.tagName === 'h1' ||
                    element.tagName === 'h2' ||
                    (element.tagName === 'p' && index <= 2) ||
                    (element.tagName === 'p' &&
                      index + 1 >= parent.children.length)
                  )
                }
              >
                {privacy}
              </ReactMarkdown>
              <p className={classes.footer}>
                <Button
                  variant="link"
                  onClick={didToogle}
                  className={classes.link}
                >
                  {t('i-got-it')}
                </Button>
              </p>
            </div>
          </div>
        </FadeIn>
      )}
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    border: '1px solid white',
  },
  subTitle: {
    fontSize: layoutDefaults.fontSize,
    fontWeight: 'normal',
  },
  link: {
    cursor: 'pointer',
    fontSize: layoutDefaults.fontSize,
    color: layoutDefaults.linkColor,
    marginLeft: layoutDefaults.smallestHorizontalMargin,
    padding: 0,
    margin: 0,
  },
  privacyContainer: {
    fontSize: layoutDefaults.fontSize,
    fontWeight: 'normal',
    // border: '1px solid red',
  },
  privacy: {
    color: '#888',
    textAlign: 'left',
    backgroundColor: '#f9f9f9',
    paddingLeft: layoutDefaults.bigHorizontalMargin - 1,
    paddingRight: layoutDefaults.bigHorizontalMargin - 1,
    paddingTop: layoutDefaults.verticalMargin,
    border: `1px ${layoutDefaults.buttonBorder} dashed`,
    borderRadius: layoutDefaults.radius,
    marginTop: layoutDefaults.verticalMargin,
    marginBottom: layoutDefaults.verticalMargin,
    // border: '1px solid red',
  },
  footer: {
    textAlign: 'right',
  },
});

export { PrivacyNotice };
